.paper {
    width: 100%;
}
